import { Link } from "react-router-dom";
import HeroCarousel from "@/components/home/HeroCarousel";
import CategoryEntries from "@/components/home/CategoryEntries";
import VideoGridSection from "@/components/home/VideoGridSection";
import { getFeaturedVideos, getHotVideos, getLatestVideos } from "@/lib/videos";

export default function Home() {
  const featured = getFeaturedVideos(5);
  const hot = getHotVideos(20);
  const latest = getLatestVideos(25);

  return (
    <div className="pb-4">
      <HeroCarousel videos={featured} />

      <div className="mx-auto max-w-[1440px] space-y-14 px-0 pt-10 md:space-y-16 md:pt-12">
        <CategoryEntries />

        <VideoGridSection
          title="热门视频"
          subtitle="近期最受欢迎的影视综艺，热度持续攀升"
          icon="ri-fire-line"
          videos={hot}
          moreTo="/category/movie"
          moreLabel="进入分类"
        />

        <VideoGridSection
          title="最新更新"
          subtitle="紧跟热点，第一时间为你带来新鲜内容"
          icon="ri-time-line"
          videos={latest}
          moreTo="/search"
          moreLabel="去搜索"
        />

        <section className="px-4 md:px-6 lg:px-8" aria-label="网站简介">
          <div className="rounded-lg border border-background-200/70 bg-background-100/70 p-6 md:p-10">
            <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.3fr_1fr] lg:items-center">
              <div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                  <i className="ri-sparkling-line"></i>
                  关于密桃视频
                </span>
                <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  丰富多彩的视频内容，一站式的浏览体验
                </h2>
                <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-700">
                  密桃视频致力于为广大影视综艺爱好者打造清晰、便捷的内容浏览平台。
                  我们按电影、电视剧、综艺三大类别整理海量视频资料，支持按地区、年份与热度多维筛选，
                  并提供详细的剧情简介与主创信息，帮助你快速找到想了解的内容。
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <Link
                    to="/category/movie"
                    className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
                  >
                    <i className="ri-compass-3-line"></i>
                    开始浏览
                  </Link>
                  <Link
                    to="/about"
                    className="inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
                  >
                    了解我们
                  </Link>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-3">
                {[
                  { value: "90+", label: "精选内容", icon: "ri-video-line" },
                  { value: "3", label: "主分类", icon: "ri-apps-2-line" },
                  { value: "5", label: "筛选维度", icon: "ri-filter-3-line" },
                ].map((stat) => (
                  <div
                    key={stat.label}
                    className="flex flex-col items-center rounded-lg border border-background-200/70 bg-background-50 px-3 py-5 text-center"
                  >
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                      <i className={`${stat.icon} text-lg`}></i>
                    </span>
                    <span className="mt-3 font-heading text-xl font-bold text-foreground-950">
                      {stat.value}
                    </span>
                    <span className="mt-1 text-xs text-foreground-600">{stat.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}